import { Box, Button, Modal, Paper } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectLabels } from "../../../slices/language";

interface AuthorizationRequestSendedModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}

const AuthorizationRequestSendedModal: React.FC<
  AuthorizationRequestSendedModalProps
> = ({ open, setOpen, onClose }) => {
  const labels = useAppSelector(selectLabels);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Box
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          style={{
            maxWidth: 450,
            minWidth: 350,
            width: "40%",
            boxSizing: "border-box",
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 30,
            paddingLeft: 30,
          }}
        >
          <p className="body-text-lg font-w-500 title-color text-center">
            {labels.authorization_sent}
          </p>
          <p className="body-text-md mt-4">
            {labels.authorization_sent_description}
          </p>
          <div className="w-100 flex justify-content-center mt-10">
            <Button
              onClick={() => {
                setOpen(false);
                onClose();
              }}
            >
              {labels.close}
            </Button>
          </div>
        </Paper>
      </Box>
    </Modal>
  );
};

export default AuthorizationRequestSendedModal;
